// Queued-message tray — `next-turn` sends sit here as compact "⏳ queued" pills
// above the composer (and are suppressed from the timeline) until the agent
// picks them up, at which point they drop into the conversation inline. Purely
// client-side: the WatchPage promotes the oldest entry when the agent next
// starts a run (see the promotion effect there).
import './pa-chat-host.css';

export type QueuedMessage = {
  localId: string;
  text: string;
  failed?: boolean;
};

export function QueuedTray({
  items,
  onRetry,
}: {
  items: QueuedMessage[];
  onRetry?: (localId: string) => void;
}) {
  if (items.length === 0) return null;
  return (
    <div className="pa-chat-queued-tray">
      {items.map((q) => (
        <div
          key={q.localId}
          className={`pa-chat-queued-pill${q.failed ? ' is-failed' : ''}`}
          title={
            q.failed
              ? 'Failed to queue — tap to retry'
              : 'Queued — runs after the current turn finishes'
          }
          onClick={q.failed && onRetry ? () => onRetry(q.localId) : undefined}
        >
          <span className="pa-chat-queued-icon">{q.failed ? '⚠' : '⏳'}</span>
          <span className="pa-chat-queued-text">{q.text}</span>
          <span className="pa-chat-queued-tag">{q.failed ? 'failed' : 'queued'}</span>
        </div>
      ))}
    </div>
  );
}
